import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { faqs } from '../data/faqs';
import './FAQ.css';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const [ref, visible] = useScrollReveal();

  return (
    <section id="faq" className="faq section">
      <div className="container">
        <div className="section-header">
          <p className="section-kicker">Common Questions</p>
          <h2 className="section-title">Straight answers for busy owner-operated businesses.</h2>
        </div>

        <div ref={ref} className={`faq-container reveal ${visible ? 'is-visible' : ''}`}>
          {faqs.map((faq, index) => (
            <div key={faq.question} className="faq-item">
              <button
                className="faq-question"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                aria-expanded={openIndex === index}
              >
                <span className="question-text">{faq.question}</span>
                <span className="question-icon">
                  {openIndex === index ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
                </span>
              </button>
              <div className={`faq-answer ${openIndex === index ? 'faq-answer-open' : ''}`}>
                <div className="answer-content">{faq.answer}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
